<template>
    <div id="remember">

        <div class="box">
            <img class="logo" src="/img/logo_top.png">
            <div id="message_password" class="message" v-show="message">{{message}}</div>
            <div class="desc">{{ $t('views.remember.description') }}</div>
            <input type="text" name="username" v-model="input.username" :placeholder="$t('views.remember.placeholder')" v-on:keyup.enter="login()" />

            <button type="button" v-on:click="remember()">{{ $t('views.remember.button') }}</button>

            <router-link to="/login" class="login">{{ $t('views.remember.login') }}</router-link>

        </div>

    </div>
</template>

<script>
    import i18n from '@/i18n';
    import {Api} from '@/core/api.js';
    const api = new Api();

    export default {
        name: 'Login',
        data() {
            return {
                input: {
                    username: "",
                },
                message: false
            }
        },
        methods: {
            remember() {
                var self = this;
                if( this.input.username.trim() !== "" ){
                    api.post( 'remember', { username: this.input.username } ).then( function( response ){
                        console.log( response );
                        if( response.status ) {
                            self.message = i18n.t('views.remember.sent');
                            document.getElementById( 'message_password' ).classList.remove( 'error' );
                            document.getElementById( 'message_password' ).classList.add( 'success' );
                            // self.$destroy();
                        } else {
                            self.message = i18n.t('views.remember.error');
                            document.getElementById( 'message_password' ).classList.remove( 'success' );
                            document.getElementById( 'message_password' ).classList.add( 'error' );
                        }
                    });
                }
                else{
                    self.message = i18n.t('views.remember.username_error');
                    document.getElementById( 'message_password' ).classList.remove( 'success' );
                    document.getElementById( 'message_password' ).classList.add( 'error' );
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    
    #remember {

        margin: auto;
        margin-top: 75px;
        padding: 20px;

        .box {
            max-width: 275px;
            width: 100%;
            margin: 0 auto;

            .logo {
                width: 100%;
                margin-bottom: 5px;
            }
            input{
                width: 100%;
                padding: 15px;
                margin-bottom: 5px;
                border: 1px solid #ccc;
                outline: none;
                font-size: 11pt;
                //background: #ddd;
                //border: none;
                //border-left: 35px solid var(--main_color);
                //border-right: 35px solid var(--main_color);

                &:focus {
                    border: 1px solid var(--main_color);
                }

            }
            button {
                width: 100%;
                padding: 15px;
                outline: none;
                border: none;
                cursor: pointer;
                font-size: 12pt;
                font-family: Speedee-Bold;
                margin-top: 5px;
                border-radius: 3px;
                text-transform: uppercase;
                transition: all 0.5s;
                background: #111;
                color: #fff;

                &:hover {
                    background: var(--main_color);
                    color: #111;
                }
            }

            .desc {
                font-size: 10pt;
                margin: 10px 0;
                color: #333;
                display: block;
            }

            .login {
                font-size: 10pt;
                margin-top: 20px;
                color: #888;
                cursor: pointer;
                display: block;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }

        }
    }

</style>